/** Relative segments under `/settings` (no leading slash). */
export const settingsPaths = {
  account: 'account',
} as const;
